// Зеркало app/services/purchases.py::compute_quantity_price — только для live-превью суммы на
// экране 2 «Оформление подписки» ДО отправки запроса; реальную сумму всегда считает backend
// (см. api/client.ts::checkout, CheckoutResponse.amount_due — источник правды).
const QUANTITY_DISCOUNTS: Record<number, number> = { 1: 0, 2: 0.2, 3: 0.3, 4: 0.4, 5: 0.5 };

// Python round() без ndigits — банковское округление (.5 к чётному), JS Math.round всегда вверх.
// Нужно совпадение с backend, иначе превью на чекауте иногда отличалось бы от реально списанной
// суммы на 1 рубль — конкретно на примере из требований пользователя: 65×3×0.7=136.5 → 136,
// не 137 (Math.round(136.5) дал бы 137).
function bankersRound(value: number): number {
  const floor = Math.floor(value);
  const diff = value - floor;
  if (diff < 0.5) return floor;
  if (diff > 0.5) return floor + 1;
  return floor % 2 === 0 ? floor : floor + 1;
}

export function computeQuantityPrice(unitPrice: number, quantity: number): number {
  const discount = QUANTITY_DISCOUNTS[quantity] ?? 0;
  return bankersRound(unitPrice * quantity * (1 - discount));
}
